import { render, staticRenderFns } from "./blog1.vue?vue&type=template&id=72caa594"
import script from "./blog1.vue?vue&type=script&lang=js"
export * from "./blog1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports